import { useEffect, useState } from 'react';

const SquareDesign = () => {
  const colors = [
    '#262626',
    '#262626',
    '#262626',
    '#fffb12',
    'rgba(255, 255, 255, 0.2)',
    '#262626',
  ];
  const [colorIndex, setColorIndex] = useState(0);
  const [isDelayed, setIsDelayed] = useState(false);

  useEffect(() => {
    const cycleLength = colors.length;
    const baseInterval = 300;
    const delay = 400;

    const interval = setInterval(
      () => {
        if (isDelayed) {
          setIsDelayed(false);
        } else {
          setColorIndex((prevIndex) => {
            const nextIndex = (prevIndex + 1) % cycleLength;
            if (nextIndex === 0) {
              setIsDelayed(true);
            }
            return nextIndex;
          });
        }
      },
      isDelayed ? delay : baseInterval,
    );

    return () => clearInterval(interval);
  }, [colors.length, isDelayed]);

  const transitionStyle = {
    transition: 'border-color 0.3s ease-in-out',
  };

  return (
    <div className='flex h-full  lg:h-[90vh] xl:h-screen  justify-center items-center -z-50'>
      <div className='framerContainer '>
        <div
          className='innerBox -z-10 bg-black'
          style={{
            ...transitionStyle,
            borderColor: colors[(colorIndex + 2) % colors.length],
          }}
        />
        <div
          className='innerBoxSecondary -z-20 bg-black'
          style={{
            ...transitionStyle,
            borderColor: colors[(colorIndex + 1) % colors.length],
          }}
        />
        <div
          className='innerBoxTertiary relative -z-30 bg-black'
          style={{
            ...transitionStyle,
            borderColor: colors[colorIndex % colors.length],
          }}
        >
          <div className='framerRamp framerRampLeft'></div>
          <div className='framerRamp framerRampRight'></div>
        </div>
        <div className='backgroundBox z-0' />
      </div>
    </div>
  );
};

export default SquareDesign;
